import { connect } from 'react-redux';
import SurveyBuilderView from './survey_builder_view';
import { getCurrentUser, getGlobalSurveysOfType } from '../../../reducer';

const mapStateToProps = (state, { surveyType }) => ({
  user: getCurrentUser(state),
  template: getGlobalSurveysOfType(state, `${surveyType}-template`).first(),
});

const SurveyBuilderContainer = connect(mapStateToProps)(SurveyBuilderView);

export default SurveyBuilderContainer;
